module.exports = __webpack_public_path__ + "static/media/star-off.16093fa1.svg";